module.exports = __webpack_public_path__ + "img/43.a731f136.jpg";